import { render, staticRenderFns } from "./SafetyworksNew.vue?vue&type=template&id=0c7271f7&"
import script from "./SafetyworksNew.vue?vue&type=script&lang=js&"
export * from "./SafetyworksNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports